import React from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb';

function BreadcrumbNav({list}) {
    return (
        <Breadcrumb className="my-1">
            {(list && Array.isArray(list) && list.length > 0) ? list.map(data => {
                return <Breadcrumb.Item key={Math.random()} className="breadcrumb-item fs-14rem">{(data.url) ? <a href={data.url}>{data.label}</a> : data.label}</Breadcrumb.Item>
            }): null}
        </Breadcrumb>
    )
}
export default BreadcrumbNav;
